import { attachmentService, cameraService } from "client-app-core";
import { subscribeFOVs, unsubscribeFOVs } from "orion-components/GlobalData/Actions";
import keys from "lodash/keys";
import pull from "lodash/pull";
import uniq from "lodash/uniq";
import { updateContext, updateContextProperty } from "orion-components/ContextualData/Actions";
import { getTranslation } from "orion-components/i18n";

export { linkEntities, unlinkEntities } from "./entityProfileActions";
export { addRemoveFromCollections, addRemoveFromEvents, updateActivityFilters } from "./commonActions";

export const attachFilesToCamera = (cameraId, entityType, files) => {
	return dispatch => {
		dispatch(updateContextProperty(cameraId, "uploadError", ""));
		attachmentService.uploadFiles(cameraId, "camera", files, (err, result) => {
			if (err) {
				console.log(err);
				switch (err.response.status) {
					case 413:
						dispatch(
							updateContextProperty(
								cameraId,
								"uploadError",
								getTranslation(
									"global.sharedActions.fileUploadFailed",
									undefined,
									getTranslation("global.sharedActions.uploadError.maxFileSizeExceeded")
								)
							)
						);
						break;
					default:
						dispatch(
							updateContextProperty(
								cameraId,
								"uploadError",
								getTranslation(
									"global.sharedActions.fileUploadFailed",
									undefined,
									getTranslation("global.sharedActions.uploadError.generic")
								)
							)
						);
						break;
				}
			}
			console.log(result);
		});
	};
};

export const showFOV = cameraId => {
	return (dispatch, getState) => {
		let cameraIds = [cameraId];
		const fovs = getState().globalData.fovs;

		//Removes duplicate entries.
		if (fovs) cameraIds = uniq([...cameraIds, ...keys(fovs.data)]);

		dispatch(subscribeFOVs(cameraIds));
	};
};

export const hideFOV = cameraId => {
	return (dispatch, getState) => {
		let cameraIds = [];
		const fovs = getState().globalData.fovs;

		if (fovs) cameraIds = pull(keys(fovs.data), cameraId);
		dispatch(unsubscribeFOVs([cameraId], fovs.subscription));
		if (cameraIds.length === 0) return;
		dispatch(subscribeFOVs(cameraIds));
	};
};

export const updateCameraGlobally = (cameraId, camera, updateEntityData) => {
	return (dispatch, getState) => {
		cameraService.update(cameraId, camera, updateEntityData, (err, response) => {
			if (err) {
				console.log(err, response);
			} else if (response?.changes) {
				const context = getState().contextualData[cameraId]?.entity || {};
				const camera = response.changes[0]?.new_val || {};
				dispatch(updateContext(cameraId, { ...context, ...camera }));
			}
		});
	};
};
